export const jobStatuses = ['scheduled', 'in_progress', 'complete', 'cancelled']

export const jobStatusLabels = {
  scheduled: 'Scheduled',
  in_progress: 'In Progress',
  complete: 'Complete',
  cancelled: 'Cancelled',
}

export const jobStatusIcons = {
  scheduled: 'mdi-calendar-clock',
  in_progress: 'mdi-progress-wrench',
  complete: 'mdi-check-circle-outline',
  cancelled: 'mdi-close-circle-outline',
}

export const jobStatusColors = {
  scheduled: { color: '#29528a', background: '#e8f1ff' },
  in_progress: { color: '#8a4b0f', background: '#fff1dc' },
  complete: { color: '#1f5c4d', background: '#e6f4ef' },
  cancelled: { color: '#59616c', background: '#eef1f4' },
}
